export const rad2deg = (radians: number) => radians * 180 / Math.PI;
export const deg2rad = (degrees: number) => degrees * Math.PI / 180;
